import { Grid as e } from "./atoms-v216.js";
import { Column as d } from "./atoms-v212.js";
import { Picture as p } from "./atoms-v233.js";
import { breakpoints as n } from "./atoms-v2125.js";
import { Base as u } from "./atoms-v2777.js";
import g, { css as s } from "styled-components";
const t = 60, c = { large: 0, max: 100, xLarge: 60 }, b = 800, l = 160, V = g(e)`
  ${u}

  /* Height logic variables (large+ only) */
  @media ${n.large} {
    /* Baseline = rate card + margin (top + bottom) */
    --rates-min-baseline: calc(var(--rate-card-h, 0px) + ${t * 2}px);

    /* Calculated height from viewport bottom minus header height and offset */
    --_visible: calc(100dvh - ${l}px - ${c.large}px);

    /* Target height: respect visible space and max height, but never below baseline */
    --rates-target-h: max(var(--rates-min-baseline), min(${b}px, var(--_visible)));
  }

  @media ${n.xLarge} {
    --_visible: calc(100dvh - ${l}px - ${c.xLarge}px);
  }

  @media ${n.max} {
    --_visible: calc(100dvh - ${l}px - ${c.max}px);
  }

  ${({ $variant: a }) => {
  if (["v1", "v2"].includes(a))
    return s`
        @media ${n.large} {
          gap: 0;
        }

        @media ${n.max} {
          gap: ${({ theme: i }) => i == null ? void 0 : i.get("tokens.breakpoints.max.gutter")}px;
        }
      `;
}}
`, C = g(d)`
  --v3-pad: 56px;
  --v3-inner-h: calc(var(--rates-target-h) - 2 * var(--v3-pad));

  display: none;

  @media ${n.large} {
    box-sizing: border-box;
    display: flex;
    height: var(--rates-target-h);
    min-height: var(--rates-min-baseline);
    padding-block: var(--v3-pad);
    padding-right: calc(60px - ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.large.gutter")}px);
  }

  @media ${n.xLarge} {
    padding-right: calc(60px - ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.xLarge.gutter")}px);
  }

  @media ${n.max} {
    padding-right: calc(60px - ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.max.gutter")}px);
  }
`, P = g(d)`
  display: none;

  @media ${n.large} {
    display: flex;
  }
`, k = g.div`
  ${({ $hideOnLarge: a, theme: i }) => {
  const r = i == null ? void 0 : i.get("tokens.breakpoints.small.margin"), o = i == null ? void 0 : i.get("tokens.breakpoints.medium.margin"), x = i == null ? void 0 : i.get("tokens.breakpoints.large.margin"), $ = i == null ? void 0 : i.get("tokens.breakpoints.xLarge.margin");
  return s`
      margin-left: calc(-1 * ${r}px);
      margin-right: calc(-1 * ${r}px);
      width: calc(100% + 2 * ${r}px);

      @media ${n.medium} {
        margin-left: calc(-1 * ${o}px);
        margin-right: calc(-1 * ${o}px);
        width: calc(100% + 2 * ${o}px);
      }

      @media ${n.large} {
        border-radius: ${i == null ? void 0 : i.get("tokens.radius.mainRadius")}px;
        display: ${a ? "none" : "flex"};
        margin-left: 0;
        margin-right: calc(-1 * ${x - 8}px);
        width: calc(100% + ${x - 8}px);
      }

      @media ${n.xLarge} {
        margin-right: calc(-1 * ${$ - 8}px);
        width: calc(100% + ${$ - 8}px);
      }

      @media ${n.max} {
        margin-right: 0;
        width: 100%;
      }
    `;
}}
`, R = g(k)`
  ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.xLarge.margin"), r = a == null ? void 0 : a.get("tokens.breakpoints.large.margin");
  return s`
      @media ${n.large} {
        margin-right: calc(-1 * ${r - 8}px);
        width: calc(100% + ${r - 8}px);
      }

      @media ${n.xLarge} {
        margin-right: calc(-1 * ${i}px);
        width: calc(100% + ${i}px);
      }

      @media ${n.max} {
        margin-right: 0;
        width: 100%;
      }
    `;
}}
`, A = g(d)`
  display: none;

  @media ${n.large} {
    display: grid;
    gap: 8px;
    grid-template-rows: minmax(0, 1fr) auto;
    height: var(--rates-target-h);
    min-height: var(--rates-min-baseline);
  }
`, _ = g.div`
  background-color: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.surface.light.layer01")};
  height: 8px;

  ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.small.margin"), r = a == null ? void 0 : a.get("tokens.breakpoints.medium.margin");
  return s`
      margin-left: calc(-1 * ${i}px);
      margin-right: calc(-1 * ${i}px);
      width: calc(100% + 2 * ${i}px);

      @media ${n.medium} {
        margin-left: calc(-1 * ${r}px);
        margin-right: calc(-1 * ${r}px);
        width: calc(100% + 2 * ${r}px);
      }
    `;
}}
`, H = g.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-block: 20px;

  @media ${n.medium} {
    gap: 32px;
    padding-block: 40px;
  }

  ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.large.margin"), r = a == null ? void 0 : a.get("tokens.breakpoints.xLarge.margin");
  return s`
      @media ${n.large} {
        background-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.surface.light.layer01")};
        border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.mainRadius")}px;
        margin-right: calc(-1 * ${i - 8}px);
        padding-inline: 32px;
        width: calc(100% + ${i - 8}px);
      }

      @media ${n.xLarge} {
        margin-right: calc(-1 * ${r}px);
        width: calc(100% + ${r}px);
      }
    `;
}}

  @media ${n.max} {
    margin-right: 0;
    width: 100%;
  }
`, M = g.div`
  ${({ theme: a }) => {
  var i;
  return (i = a == null ? void 0 : a.get("tokens.heading.02")) == null ? void 0 : i.toJS();
}}

  @media ${n.medium} {
    ${({ theme: a }) => {
  var i;
  return (i = a == null ? void 0 : a.get("tokens.heading.03")) == null ? void 0 : i.toJS();
}}
  }
`, E = g.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  @media ${n.medium} {
    display: grid;
    gap: 12px 32px;
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${n.large} {
    gap: 12px;
  }
`, G = g.div`
  ${({ theme: a }) => {
  var i;
  return (i = a == null ? void 0 : a.get("tokens.helper.productive")) == null ? void 0 : i.toJS();
}}

  align-items: center;
  background: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.surface.light.layer01")};
  border-radius: 1000px;
  display: flex;
  height: 24px;
  justify-content: center;
  padding-inline: 8px;
  white-space: nowrap;

  @media ${n.medium} {
    ${({ theme: a }) => {
  var i;
  return (i = a == null ? void 0 : a.get("tokens.body.expressive")) == null ? void 0 : i.toJS();
}}
    background: transparent;
    border-radius: 0;
    display: block;
    height: auto;
    padding-inline: 0;
    white-space: normal;
  }

  @media ${n.large} {
    ${({ theme: a }) => {
  var i;
  return (i = a == null ? void 0 : a.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}
  }
`, I = g(p)`
  @media ${n.large} {
    aspect-ratio: unset;
    border-radius: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.radius.mainRadius")}px;
    height: var(--rates-target-h);
    object-fit: cover;
    width: 100%;
  }
`, S = g(p)`
  @media ${n.large} {
    aspect-ratio: unset;
    border-radius: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.radius.mainRadius")}px;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`, j = g(p)`
  @media ${n.large} {
    aspect-ratio: unset;
    border-radius: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.radius.cardRadiusMed")}px;
    height: var(--v3-inner-h);
    object-fit: cover;
    width: 100%;
  }
`, T = g(p)`
  aspect-ratio: unset;
  border-radius: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.radius.cardRadiusMed")}px;
  height: ${({ $isFirst: a }) => +a ? "calc(var(--v3-inner-h) - 200px)" : "var(--v3-inner-h)"};
  max-height: var(--v3-inner-h);
  object-fit: cover;
  width: 100%;
`, X = g.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: flex-start;
`, J = g(d)`
  @media ${n.large} {
    align-self: center;
    padding-bottom: ${t}px;
    padding-top: ${t}px;
  }

  @media (min-width: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.large.size")}px) and (max-width: ${({
  theme: a
}) => (a == null ? void 0 : a.get("tokens.breakpoints.xLarge.size")) - 0.02}px) {
    ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.large.margin");
  return s`
        box-sizing: border-box;
        margin-left: calc(-1 * ${i}px);
        margin-right: ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.large.gutter")}px;
        padding-left: 56px;
        padding-right: calc(56px - ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.large.gutter")}px);
      `;
}}
  }

  @media (min-width: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.xLarge.size")}px) and (max-width: ${({
  theme: a
}) => (a == null ? void 0 : a.get("tokens.breakpoints.max.size")) - 0.02}px) {
    ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.xLarge.margin");
  return s`
        box-sizing: border-box;
        margin-left: calc(-1 * ${i}px);
        margin-right: ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.xLarge.gutter")}px;
        padding-left: 80px;
        padding-right: calc(80px - ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.xLarge.gutter")}px);
      `;
}}
  }
`, N = g(d)`
  @media ${n.large} {
    align-self: center;
    padding-bottom: ${t}px;
    padding-top: ${t}px;
  }

  @media (min-width: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.large.size")}px) and (max-width: ${({
  theme: a
}) => (a == null ? void 0 : a.get("tokens.breakpoints.xLarge.size")) - 0.02}px) {
    ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.large.margin");
  return s`
        box-sizing: border-box;
        margin-left: calc(-1 * ${i}px);
        margin-right: ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.large.gutter")}px;
        padding-left: 56px;
        padding-right: calc(56px - ${({ theme: r }) => r == null ? void 0 : r.get("tokens.breakpoints.large.gutter")}px);
      `;
}}
  }

  @media (min-width: ${({ theme: a }) => a == null ? void 0 : a.get("tokens.breakpoints.xLarge.size")}px) and (max-width: ${({
  theme: a
}) => (a == null ? void 0 : a.get("tokens.breakpoints.max.size")) - 0.02}px) {
    ${({ theme: a }) => {
  const i = a == null ? void 0 : a.get("tokens.breakpoints.xLarge.margin");
  return s`
        box-sizing: border-box;
        margin-left: calc(-1 * ${i}px);
        padding-left: 80px;
        padding-right: 80px;
      `;
}}
  }
`, m = g.div`
  width: 100%;
`, B = g(d)`
  @media ${n.large} {
    align-self: center;
    padding-bottom: ${t}px;
    padding-top: ${t}px;
  }
`;
export {
  H as AmenitiesContainer,
  E as AmenitiesList,
  M as AmenitiesTitle,
  G as Amenity,
  B as ContentColumnV3,
  J as FirstColumnV1,
  N as FirstColumnV2,
  P as PictureColumn,
  C as PictureColumnV3,
  k as PictureWrapper,
  R as PictureWrapperV2,
  m as RateCard,
  V as Rates,
  I as V1Picture,
  _ as V2Divider,
  S as V2Picture,
  A as V2PictureColumn,
  T as V3LargePicture,
  j as V3Picture,
  X as V3PictureContainer
};
